import { Pane, Heading, Button, Badge, Select, PlusIcon, CalendarIcon, RepeatIcon } from 'evergreen-ui';

const MESI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
const ANNI = [2024, 2025, 2026, 2027, 2028];

export default function TurniHeader({
  selectedMonth,
  setSelectedMonth,
  coveragePercentage,
  coveredMonthHours,
  expectedMonthHours,
  showOnlyUncovered,
  setShowOnlyUncovered,
  isDirector,
  isEducator,
  isOperator,
  onInsert,
  onOrarioFisso,
  onFerie,
  onMieFerie,
  onGestioneFerie,
}) {
  const [selYear, selMonth] = selectedMonth.split('-');

  return (
    <Pane display="flex" flexDirection="column" gap={16} marginBottom={32}>
      <Pane display="flex" flexDirection="column" gap={16}>
        <Pane display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={16}>
          <Pane flex={1} minWidth={280}>
            <Heading size={800} color="#2a3b2c" marginBottom={12}>Gestione turni lavorativi</Heading>
            <Pane display="flex" alignItems="center" gap={16} flexWrap="wrap">
              <Badge
                color={coveragePercentage < 50 ? 'red' : coveragePercentage < 80 ? 'yellow' : 'green'}
                isSolid
                paddingX={8} paddingY={4}
                style={{ whiteSpace: 'normal', height: 'auto', lineHeight: '1.5' }}
              >
                Copertura Mensile: {coveragePercentage}% ({Math.round(coveredMonthHours)}h / {expectedMonthHours}h coperte)
              </Badge>
              <Pane display="flex" alignItems="center" gap={8}>
                <Select
                  value={selMonth}
                  onChange={e => setSelectedMonth(`${selYear}-${e.target.value}`)}
                  height={32}
                >
                  {['01','02','03','04','05','06','07','08','09','10','11','12'].map((m, i) => (
                    <option key={m} value={m}>{MESI[i]}</option>
                  ))}
                </Select>
                <Select
                  value={selYear}
                  onChange={e => setSelectedMonth(`${e.target.value}-${selMonth}`)}
                  height={32}
                >
                  {ANNI.map(y => <option key={y} value={String(y)}>{y}</option>)}
                </Select>
              </Pane>
            </Pane>
          </Pane>
        </Pane>

        <Pane width="100%" display="flex" gap={12} alignItems="center" flexWrap="wrap" justifyContent="flex-start" marginTop={8}>
          <Button intent={showOnlyUncovered ? 'danger' : 'none'} onClick={() => setShowOnlyUncovered(!showOnlyUncovered)}>
            {showOnlyUncovered ? 'Mostra tutte le giornate' : 'Mostra le giornate scoperte/parziali'}
          </Button>

          {isDirector && (
            <Button iconBefore={PlusIcon} intent="success" appearance="primary" onClick={onInsert}>
              Inserisci turno
            </Button>
          )}

          {isDirector && (
            <Button iconBefore={RepeatIcon} onClick={onOrarioFisso}>
              Inserisci turni con ripetizione orario fisso
            </Button>
          )}

          <Button iconBefore={CalendarIcon} onClick={onFerie}>
            {isDirector ? 'Inserisci ferie' : 'Richiedi ferie'}
          </Button>

          {!isDirector && (isEducator || isOperator) && (
            <Button onClick={onMieFerie}>Visualizza richieste ferie</Button>
          )}

          {isDirector && (
            <Button onClick={onGestioneFerie} intent="warning" appearance="primary">
              Gestione ferie
            </Button>
          )}
        </Pane>
      </Pane>
    </Pane>
  );
}
